"use client";

import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { Link } from "@/components/common/Link";
import { Card, CardContent } from "@/components/ui/card";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { ChevronRight } from "lucide-react";
function NewsMediaConsumer() {
  const {
    posts,
    loading,
    error
  } = usePosts();
  if (loading) {
    return <div className="space-y-6">
        {[...Array(4)].map((_, i) => <div key={i} data-index={i} className="h-40 rounded-xl bg-muted/30 animate-pulse" />)}
      </div>;
  }
  if (error) {
    return <div className="text-sm text-muted-foreground">
        Failed to load news articles.
      </div>;
  }
  if (posts.length === 0) {
    return <p className="text-muted-foreground">No news articles to display.</p>;
  }
  return <div className="space-y-6">
      {posts.map((post, i) => <Card key={post.id} data-index={i} className="group overflow-hidden transition-all duration-300 ease-out hover:shadow-medium">
          <CardContent className="p-0">
            <div className="grid grid-cols-1 gap-6 md:grid-cols-[280px_1fr] items-start">
              {}
              {post.featuredImage && <div className="overflow-hidden rounded-tl-xl rounded-bl-xl md:rounded-bl-none md:rounded-tr-none md:rounded-tl-xl">
                  <AspectRatio ratio={16 / 9}>
                    <img src={post.featuredImage} alt={post.title} className="h-full w-full object-cover transition-transform duration-300 ease-out group-hover:scale-[1.04]" />
                  </AspectRatio>
                </div>}

              {}
              <div className="flex flex-col justify-center gap-3 p-6">
                {}
                {post.date && <time className="text-sm text-muted-foreground">
                    {new Date(post.date).toLocaleDateString("en-US", {
                year: "numeric",
                month: "long",
                day: "numeric"
              })}
                  </time>}

                {}
                <h3 className="text-xl font-semibold leading-tight text-foreground transition-all duration-150 ease-out group-hover:underline group-hover:underline-offset-4">
                  {post.title}
                </h3>

                {}
                {post.excerpt && <div className="text-sm text-muted-foreground line-clamp-2" dangerouslySetInnerHTML={{
              __html: post.excerpt
            }} />}

                {}
                {post.link && <Link to={post.link} className="inline-flex items-center gap-1 text-sm font-medium text-primary transition-all duration-150 ease-out group-hover:gap-2">
                    Read more
                    <ChevronRight className="h-4 w-4" />
                  </Link>}
              </div>
            </div>
          </CardContent>
        </Card>)}
    </div>;
}
export default function NewsMedia() {
  return <section className="w-full bg-background py-16 px-6 md:px-8 lg:px-12">
      <div className="mx-auto max-w-5xl">
        <div className="mb-10">
          <h2 className="text-3xl font-display font-bold text-foreground md:text-4xl">
            News & Media
          </h2>
        </div>

        <PostsProvider className="news-media-provider" wp_query={{
        per_page: 6,
        order: "desc",
        orderby: "date"
      }} embeds={["wp:featuredmedia"]} fields={["id", "title.rendered", "excerpt.rendered", "link", "date", "_embedded", "_links.wp:featuredmedia"]}>
          <NewsMediaConsumer />
        </PostsProvider>
      </div>
    </section>;
}